module.exports = __webpack_public_path__ + "images/stjosephwhite.png";


//////////////////
// WEBPACK FOOTER
// ./assets/stjosephwhite.png
// module id = 2
// module chunks = 0